//Home map
if(window.innerWidth > 960) {

    let map = document.querySelector('.map__item');
    let tooltip = document.querySelector('.map__tooltip');

    if (map) {
        map.addEventListener('mousemove', function (e) {
            let bounds = map.getBoundingClientRect();
            
            tooltip.style.top = e.clientY - bounds.top - 72 + 'px';
            tooltip.style.left = e.clientX - bounds.left - 85 + 'px'; 
        });
    }


    // Au hover sur les différentes villes (SVG)

    let citiesMap = document.querySelectorAll('.map__item svg a'); // on sélectionne dans le DOM toutes les villes contenues dans le SVG
    console.log(citiesMap)

    if (citiesMap) {
        citiesMap.forEach(city => { // on itère sur le tableau citiesMap
            city.addEventListener('mouseover', (event) => { // à chaque SVG de ville survolé
                // if (city.classList.contains('map__hoverTooltip')) {
                    tooltip.classList.add('active');
                    tooltip.append(city.getAttribute('data-title'));
                // }
            });

            city.addEventListener('mouseout', (event) => { // si on ne survole plus la ville en question            
                tooltip.classList.remove('active');
                tooltip.innerHTML = "";
            });
        });
    }
}